module.exports = require("github:xdan/datetimepicker@2.5.4/build/jquery.datetimepicker.full.min.js");